import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiBusinessPhotoGeneratorConfig } from '@/data/landingConfig/landingAiBusinessPhotoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiBusinessPhotoGenerator } from './schemaObject';

interface Props {}
const AiBusinessPhotoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiBusinessPhotoGenerator} />
			<LandingTemplate
				data={landingAiBusinessPhotoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelHeadshotGenerator()}
			/>
		</>
	);
};

export default AiBusinessPhotoGenerator;
